// src/icons/MetabolicHealthWaveIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function MetabolicHealthWaveIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        clipRule: "evenodd",
        d: "M20.499 6.73098C17.5766 2.02529 11.3804 0.596176 6.61281 3.50629C5.63187 4.10505 2.54065 6.2553 1.99374 11.0853C1.9316 11.634 1.43635 12.0285 0.887577 11.9664C0.338799 11.9042 -0.0556992 11.409 0.00644066 10.8602C0.65352 5.14565 4.35067 2.54395 5.57079 1.79919C11.2568 -1.67156 18.6842 0.0179238 22.198 5.67582C25.7111 11.3325 23.9302 18.7384 18.2326 22.2162C12.5401 25.6909 5.08103 23.936 1.5712 18.2845C0.580705 16.6897 1.46572 14.8855 2.56075 13.9759C3.30977 13.3537 4.27921 12.5973 5.24096 11.9912C5.72167 11.6883 6.21967 11.4106 6.70136 11.2059C7.16872 11.0072 7.69526 10.8446 8.21212 10.8446C8.9857 10.8446 9.60982 11.0002 10.1408 11.258C10.6575 11.5089 11.0428 11.8375 11.336 12.096C11.3507 12.1089 11.3652 12.1217 11.3795 12.1343C11.9472 12.6349 12.1887 12.8479 12.7587 12.8479C12.9717 12.8479 13.2835 12.7776 13.691 12.6014C14.0885 12.4295 14.5201 12.1818 14.9554 11.8902C15.8278 11.3058 16.6378 10.5974 17.1065 10.1328C17.4987 9.74392 18.1318 9.74666 18.5207 10.1389C18.9095 10.5311 18.9068 11.1642 18.5145 11.5531C17.9729 12.0901 17.0653 12.8841 16.0685 13.5518C15.5692 13.8863 15.0284 14.202 14.4849 14.4371C13.9516 14.6677 13.354 14.8479 12.7587 14.8479C11.4158 14.8479 10.6543 14.168 10.1217 13.6925C10.0847 13.6594 10.0487 13.6273 10.0137 13.5965C9.73865 13.3541 9.52403 13.1819 9.26717 13.0571C9.02458 12.9393 8.7015 12.8446 8.21212 12.8446C8.08547 12.8446 7.84732 12.892 7.4837 13.0465C7.13443 13.195 6.73518 13.4136 6.30728 13.6833C5.45181 14.2224 4.55858 14.9163 3.83871 15.5143C3.13749 16.0968 3.02808 16.8395 3.27021 17.2294C6.19664 21.9415 12.4295 23.4152 17.1906 20.5091C21.9465 17.606 23.4222 11.4379 20.499 6.73098Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }),
      /* @__PURE__ */ jsx("defs", {
        children: /* @__PURE__ */ jsx("clipPath", {
          children: /* @__PURE__ */ jsx("rect", {
            fill: "currentColor",
            height: 24,
            width: 24
          })
        })
      })
    ]
  });
}
export {
  MetabolicHealthWaveIcon
};
//# sourceMappingURL=MetabolicHealthWaveIcon.mjs.map